__turbopack_context__.v({
  "buttons": "BrowserWindow-module-scss-module__3-riAa__buttons",
  "content": "BrowserWindow-module-scss-module__3-riAa__content",
  "dot": "BrowserWindow-module-scss-module__3-riAa__dot",
  "toolbar": "BrowserWindow-module-scss-module__3-riAa__toolbar",
  "window": "BrowserWindow-module-scss-module__3-riAa__window",
});
